<require from="./my-app.scss"></require>
<import from="./views/top-nav-bar/top-nav-bar"></import>
<import from="./views/main-body-tab-bar/main-body-tab-bar"></import>
<import from="./views/footer/footer"></import>

<div class="app">
  <top-nav-bar class="top-nav-bar"></top-nav-bar>
  <main-body-tab-bar class="main-body-tab-bar"></main-body-tab-bar>
  <app-footer  class="footer"></app-footer>
</div>
